import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CategoriesForBrandQueryVariables = Types.Exact<{
  accountId: Types.Scalars['ID']['input'];
  brandId: Types.Scalars['String']['input'];
}>;


export type CategoriesForBrandQuery = { __typename?: 'Query', categoriesForBrand?: Array<{ __typename?: 'BrandCategory', category?: string | null, type?: string | null }> | null };


export const CategoriesForBrand = /*#__PURE__*/ gql`
    query CategoriesForBrand($accountId: ID!, $brandId: String!) {
  categoriesForBrand(accountId: $accountId, brandId: $brandId) {
    category
    type
  }
}
    ` as unknown as DocumentNode<CategoriesForBrandQuery, CategoriesForBrandQueryVariables>;

          

          export const useCategoriesForBrandQuery = (options?:QueryHookOptions<CategoriesForBrandQuery, CategoriesForBrandQueryVariables>) => useQuery(CategoriesForBrand, options);

          

          export type CategoriesForBrandQueryOptions = QueryHookOptions<CategoriesForBrandQuery, CategoriesForBrandQueryVariables>;

          

          export const useCategoriesForBrandLazyQuery = (options?:LazyQueryHookOptions<CategoriesForBrandQuery, CategoriesForBrandQueryVariables>) => useLazyQuery(CategoriesForBrand, options);

          

          export type CategoriesForBrandQueryResult = ReturnType<typeof useCategoriesForBrandQuery>;

          
